import React from "react";
import RenderDate from "../../../Common/Date/RenderDate";
import {Typography} from "@mui/material";

const SignOff = ({signOff, resourceType}) => {

    return (
        <>
            {Array.isArray(signOff?.log) && (
                signOff.log.map((log, index) => (
                    <React.Fragment key={index}>
                        <Typography variant={'body1'} mb={2}>
                           <strong>{log?.signatory?.name || ''}</strong>
                            &nbsp;{log?.status || ''}
                            &nbsp;<strong>{resourceType}</strong>
                            &nbsp;<RenderDate date={log.date} />
                        </Typography>
                        <Typography variant={'body1'} className="comment" mb={4} >{log?.notes || ''}</Typography>
                    </React.Fragment>
                ))
            )}
        </>
    )
}

export default SignOff;